import React from 'react'

const SvgTennisFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.965 10.77a10.005 10.005 0 00-8.736-8.734 11.012 11.012 0 008.736 8.735zM22 12.808A13.01 13.01 0 0111.193 2a10.002 10.002 0 00-9.123 9.123A13.01 13.01 0 0112.877 21.93 10.003 10.003 0 0022 12.807zm-11.16 9.088a11.011 11.011 0 00-8.735-8.735 10.005 10.005 0 008.735 8.735z'
    />
  </svg>
)

export default SvgTennisFilled
